<template>
    <div id="home">
        <hero />

        <div id="skillset" class=" section py-4">
            <section-title>Skillset <em>&amp;&amp;</em> Technologien</section-title>
            <div class="features py-4 mb-4">
          <div class="container">
            <div class="row">
                <feature :icon="['fas', 'code']">
                    <h5>PHP &amp; Backend-Development</h5>
                    <p>
                        PHP Entwicklung mit Schwerpunkt auf dem <tag>Symfony</tag> Framework für individual Entwicklungen.
                        Integration und Entwicklung für Content-Management-Systeme
                        <tag>TYPO3</tag> und
                        <tag>Craft CMS</tag> auf Senior-Level. <br>
                        Test-Driven-Development auf Basis von <tag>PHPUnit</tag></p>
                </feature>
                <feature :icon="['fas', 'cloud']">
                    <h5>Dev-Ops &amp; SRE</h5>
                    <p>
                        Einsatz von Cloud-Computing Themen im Dev-Ops &amp; Site Reliability Engineering mit <tag>Docker</tag>, Continuous integration <tag>CI</tag>
                        auf Basis von <tag>GitLab-Pipelines</tag> - Weitgehende Kenntnisse im Bereich <tag>AWS</tag>,<tag>Google Cloud</tag> und <tag>Kubernetes</tag>
                    </p>
                </feature>
                <feature :icon="['fab' ,'vuejs']">
                    <h5>Frontend-Development</h5>
                    <p>Frontend-Entwicklung auf modernstem Stand in <tag>HTML5 / CSS3</tag> mit aktuellsten
                        <tag>JavaScript</tag> Technologien - inkl.
                        <tag>Vue.JS</tag> und <tag>Node JS</tag>
                    </p>
                </feature>

                <!--
                <feature icon="fa fa-rocket">
                    <h5>Code for Equity</h5>
                    <p>Ne geile Startup-Idee? Keine Ahnung ob technisch möglich oder kein Talent am Start?
                        Lass uns quatschen!
                    </p>
                </feature>
                -->

                <feature :icon="['fas' ,'chalkboard-teacher']">
                    <h5>Beratung &amp; Schulung</h5>
                    <p>
                        IT-Consulting in allen genannten Technologien und Frameworks - Machbarkeitsstudien, Beratung und Schulung
                        bei Integration
                    </p>
                </feature>
            </div>
          </div>
        </div>
        <!-- / Features -->
      </div>

      <div id="tools" class="section section-invert py-4">
          <logos></logos>
      </div>

        <!--
        <div id="projets" class="section py-4">
            <section-title>Die letzten Projekte</section-title>
            <referenzen></referenzen>
        </div>
        -->

      <div id="contact" class="section py-4">
          <section-title>Kontakt</section-title>
          <div class="container">
              <contact />
          </div>
      </div>
    </div>
</template>

<script>
import Feature from '@/components/Feature';
import Logos from '@/components/Logos';
import Referenzen from './Referenzen';
import Contact from '@/components/Contact';

export default {
    components: {
        Feature,
        Logos,
        Referenzen,
        Contact
    }
}
</script>
